import s from './index.module.less';

// 展示摘自现有项目正文（2026-09-13）；限定词与评测范围随指标一起展示。
// 不按数字自动加粗，避免将版本号、日期或容量规划误当作成果。
export const projectEvidence = {
    '智能问数 Agent：业务自助分析与 Lattice 数仓协同': {
        items: [
            ['10 个', '审核模板题', '端到端验收通过'],
            ['≥90%', '标准题口径正确率', '高频标准题验收范围'],
            ['至少 86 万元', '每年节省成本', '相关数据能力建设与成本优化'],
        ],
        emphasis: ['10 个模板题端到端验收通过', '高频标准题口径正确率不低于 90%', '验收范围内越权结果与不合规 SQL 提交均为 0', '每年节省至少 86 万元'],
    },
    'Game Factory：自然语言驱动的游戏生成 Agent': {
        scope: '限定玩法样本的实现与验证',
        items: [
            ['生成链路', '已完成验证', '真实模型与生图调用、H5 产物生成'],
            ['移动交互', '八态交互验证', '限定玩法样本'],
            ['可靠运行', '已有专项验证', '状态恢复、动作幂等与运行隔离'],
        ],
        qualitative: true,
        emphasis: ['限定玩法样本已完成真实模型与生图调用、H5 产物生成及移动端八态交互验证', '服务端状态恢复、动态启动、动作幂等及生成代码网络隔离已有专项验证', '形成可追溯的游戏包与运行记录'],
    },
    '企业知识库：知识编译、证据检索与 Agentic 调查': {
        items: [
            ['全部业务线', '集团内部接入使用', '知识查询、规范检索与新人赋能'],
            ['452 道', '评测集题目', '已扩展的评测规模'],
            ['0.825', '答案正确性', '评测集结果'],
        ],
        emphasis: ['已接入集团内部全部业务线使用', '评测集扩展至 452 道题，答案正确性达 0.825'],
    },
    'LatticeFlow 高速数仓：Rust 计算内核与实时数据平台': {
        items: [
            ['约 1.78 亿条/日', '源事件规模', '投注、返奖两类事件 · 24 小时统计'],
            ['3 个', '业务平台监控', '近 1 小时提现失败原因监控'],
            ['10 分钟', '充值、提现成功率预警', '实时主链路与业务任务已生产交付'],
        ],
        emphasis: ['核心 Rust 方案已完成实现并验证性能提升', '约 1.78 亿条/日', '主链路及业务任务已上线生产', '3 个业务平台', '10 分钟充值、提现成功率预警', '完成需求方验收'],
    },
    'BILM 高性能关系索引与持久化系统（Go）': {
        scope: '同一关系索引验证规模的两个维度',
        items: [
            ['3000 万', 'largeID 规模', '已完成验证'],
            ['500', 'smallID 规模', '已完成验证'],
        ],
        emphasis: ['largeID 3000 万 / smallID 500 级别规模下完成验证', '显著降低内存占用与快照峰值', '减少写路径阻塞时间'],
    },
    '全球站推荐：用户节奏感知的受约束收益优化推荐系统': {
        items: [
            ['状态优先', '用户分群与策略切换', '面向用户生命周期'],
            ['多目标排序', '动态调整排序权重', '结合用户状态'],
            ['风险硬约束', '推荐结果可控', '支持用户节奏保护'],
        ],
        qualitative: true,
        emphasis: ['提升分群稳定性与可解释性', '通过状态优先级驱动推荐策略切换', '避免单一 ROI 贪心失控', '实现推荐结果的工程可控与节奏保护'],
    },
    '达人智选：多链路召回与社交协同驱动的KOL智能推荐系统': {
        items: [
            ['≥85%', '召回命中率', '多链路召回'],
            ['+23%', 'Feed 点击率', 'Feed 流推荐'],
            ['超 30%', '联合推荐覆盖', '推荐任务场景'],
            ['超 20 个', '游戏项目组接入', '已接入项目组流程'],
        ],
        emphasis: ['召回命中率≥85%', 'Feed点击率提升23%', '机制已覆盖超30%推荐任务场景', '目前已接入超20个游戏项目组流程'],
    },
    '自动化数据分析管线': {
        items: [
            ['逾 60%', '推理成本下降', '分析工具复用与解耦调度'],
            ['+10.7%', '召回率提升', '改造版 NvBench 评估'],
            ['超 70%', '初级分析师工时可替代', '改造版 NvBench 评估'],
        ],
        emphasis: ['推理成本整体下降逾 60%', '召回率提升 10.7%，可替代初级分析师工时超 70%', '已实现多业务结构间的模板级自动适配'],
    },
    '星瞳 text2motion 动作生成系统': {
        items: [
            ['≥80%', '主流动作生成成功率', '支持中英双语文本驱动'],
            ['3 次', '“直播 3D 回”运行', '这 3 次运行均为 0 bug'],
        ],
        emphasis: ['主流动作生成成功率≥80%', '已完成3次“直播3D回”的0bug运行'],
    },
    '基于强化学习的碳中和政策模拟系统': {
        scope: '模拟环境下的最优策略结果',
        items: [
            ['−18%', '碳排放', '模拟环境最优策略'],
            ['−12%', '社会成本', '模拟环境最优策略'],
            ['−21%', '策略波动性', '模拟环境最优策略'],
        ],
        emphasis: ['最优策略在模拟环境下实现碳排放下降 18%、社会成本降低 12%', '策略波动性减少 21%'],
    },
};

export const emphasizeEvidence = (text, phrases = []) => {
    if (!text || !phrases.length) return text;
    const matches = phrases.filter((phrase) => text.includes(phrase)).sort((a, b) => b.length - a.length);
    if (!matches.length) return text;
    const pattern = new RegExp(`(${matches.map((phrase) => phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'g');
    return text.split(pattern).map((part, index) => matches.includes(part)
        ? <strong className={s.evidenceEmphasis} key={index}>{part}</strong>
        : part);
};

const ProjectEvidence = ({card, heading}) => {
    const evidence = projectEvidence[card.title];
    return <section className={s.summaryDialogResult}>
        <h3>{heading}</h3>
        {evidence?.scope ? <p className={s.projectEvidenceScope}>{evidence.scope}</p> : null}
        {evidence ? <div className={s.projectEvidenceGrid} data-count={evidence.items.length}>
            {evidence.items.map(([value, label, scope]) => <div className={s.projectEvidenceMetric} key={label}>
                <strong className={evidence.qualitative ? s.projectEvidenceStatement : s.projectEvidenceValue} data-compact={value.length > 8 || undefined}>{value}</strong>
                <div><span className={s.projectEvidenceLabel}>{label}</span><small>{scope}</small></div>
            </div>)}
        </div> : null}
        <p className={evidence ? s.projectEvidenceContext : undefined}>{card.metric}</p>
    </section>;
};

export default ProjectEvidence;
